<div class="mb-3">
    <label class="form-label fw-medium mb-2" [for]="inputId" [class.disabled]="ngControl.disabled">
        {{ label() }}
        @if (inputRequiredIndicatorEnabled()) {
            <span class="text-danger"> *</span>
        }
    </label>
    <div class="tel-input" [class.is-invalid]="ngControl.touched && ngControl.invalid">
        <select
            class="tel-input__country"
            aria-label="Country code"
            [ngModel]="country()"
            [disabled]="ngControl.disabled"
            (ngModelChange)="onCountryChange($event)"
        >
            @for (c of countries; track c.iso) {
                <option [value]="c.iso">{{ c.flag }} {{ c.name }}</option>
            }
        </select>
        <input
            [id]="inputId"
            type="tel"
            class="tel-input__number"
            [placeholder]="placeholder()"
            [ngModel]="nationalNumber()"
            [disabled]="ngControl.disabled"
            (ngModelChange)="onNumberInput($event)"
            (blur)="onBlur()"
        />
    </div>
    @if (ngControl.touched) {
        @if (ngControl.control?.errors?.['required']) {
            <div class="invalid-feedback d-block">{{ label() | titlecase }} cannot be empty</div>
        } @else if (ngControl.control?.errors?.['invalidPhone']) {
            <div class="invalid-feedback d-block">Enter a valid phone number for the selected country</div>
        }
    }
</div>
